import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';
import { SERVER_URL } from './apiConstants';

const headers = {
  'Content-Type': 'application/json; charset=utf-8',
  'Access-Control-Allow-Origin': '*',
};
const signup = 'signup';
export const signUp = createAsyncThunk('api/signup', async (data, { rejectWithValue }) => {
  const body = {
    name: data.name,
    email: data.email,
    phone: data.phone,
    password: data.password,
    businessName: data.businessName,
    userType: data.userType,
  };
  try {
    const response = await axios.post(`${SERVER_URL}/${signup}`, body, { headers });
    return response.data;
  } catch (e) {
    const message =
      e?.response?.data?.message ||
      e?.response?.data?.error ||
      e?.message ||
      'Registration failed. Please try again.';
    return rejectWithValue({ message, status: e?.response?.status });
  }
});

const registrationSlice = createSlice({
  name: 'api',
  initialState: {
    loading: false,
    signupData: {},
    error: '',
  },
  extraReducers: {
    [signUp.pending]: (state) => {
      /* eslint-disable no-param-reassign */
      state.loading = true;
    },
    [signUp.fulfilled]: (state, action) => {
      state.loading = false;
      state.signupData = action.payload;
      if (action.payload && action.payload.data) {
        toast.success(
          'An OTP has been sent to your email address. Please check your inbox and enter the OTP to verify your account.'
        );
      }
    },
    [signUp.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload?.message || 'Registration failed.';
    },
  },
});

export default registrationSlice.reducer;
